import axios from 'axios';
import { hasFeature } from 'utils/featureFlags';
import { GET_PROFILE, GET_PROFILE_V2 } from '../constants';

export function getProfile(query) {
  const url = hasFeature('enable-cmp-indicators')
    ? GET_PROFILE_V2
    : GET_PROFILE;

  return axios
    .get(url, { params: query, withCredentials: false })
    .catch(error => {
      if (error?.response?.data?.error?.user_message) {
        throw new Error(error.response.data.error.user_message);
      }
      throw error;
    });
}
